import { Component, computed, OnDestroy, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../../components/content/content.component';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  ApplicationAppEntityApplicationRead,
  ServiceAppEntityServiceRead,
  ShipmentAppEntityShipmentRead
} from '../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending,
  selectShipments
} from '../../../store/selectors/application.selectors';
import {
  fakeSignApplication,
  loadApplication,
  loadPayments,
  loadRoadOccupationTypes,
  loadServiceAttachmentPositions,
  loadShipments,
  sendApplication,
  setApplication,
  setPayments,
  setShipments,
  signApplication
} from '../../../store/actions/application.actions';
import { selectServiceByUrl } from '../../../store/selectors/app.selectors';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { UploaderAttachmentsService } from '../../../services/uploader-attachments.service';
import { AlertContainerComponent, AlertService } from '../../../common/alert-container/alert-container.component';
import {
  WLocationPropertyInRevitalizationAreaPreviewComponent
} from '../application/w-location-property-in-revitalization-area/w-location-property-in-revitalization-area-preview/w-location-property-in-revitalization-area-preview.component';
import {
  WCertificateFromMunicipalRegisterPreviewComponent
} from '../application/w-certificate-from-municipal-register/w-certificate-from-municipal-register-preview/w-certificate-from-municipal-register-preview.component';
import {
  WExtractAndDraftMpzpPreviewComponent
} from '../application/w-extract-and-draft-mpzp/w-extract-and-draft-mpzp-preview/w-extract-and-draft-mpzp-preview.component';
import {
  WExtractAndDraftFromStudyPreviewComponent
} from '../application/w-extract-and-draft-from-study/w-extract-and-draft-from-study-preview/w-extract-and-draft-from-study-preview.component';
import {
  CertAboutConformityOfUseWithMpzpPreviewComponent
} from '../application/cert-about-conformity-of-use-with-mpzp/cert-about-conformity-of-use-with-mpzp-preview/cert-about-conformity-of-use-with-mpzp-preview.component';
import {
  OpinionOfConformityPreviewComponent
} from '../application/opinion-of-conformity/opinion-of-conformity-preview/opinion-of-conformity-preview.component';
import {
  IrspaApplicationForTheProjectPreviewComponent
} from '../application/irspa-application-for-the-project/irspa-application-for-the-project-preview/irspa-application-for-the-project-preview.component';
import {
  IrspaWarningOnTheConsultedDraftPreviewComponent
} from '../application/irspa-warning-on-the-consulted-draft/irspa-warning-on-the-consulted-draft-preview/irspa-warning-on-the-consulted-draft-preview.component';
import {
  IrspaAmendTheActPreviewComponent
} from '../application/irspa-amend-the-act/irspa-amend-the-act-preview/irspa-amend-the-act-preview.component';
import {
  IrspaPreparationOfTheActPreviewComponent
} from '../application/irspa-preparation-of-the-act/irspa-preparation-of-the-act-preview/irspa-preparation-of-the-act-preview.component';
import { PaymentStatusCheckerComponent } from '../../../common/payment-status-checker/payment-status-checker.component';
import { PdfGeneratorService } from '../../../services/pdf.generator.service';
import {
  DocumentsInformationPreviewComponent
} from '../application/documents-information/documents-information-preview/documents-information-preview.component';
import {
  GeneralLetterPreviewComponent
} from '../application/general-letter/general-letter-preview/general-letter-preview.component';
import {
  ResponseToCallPreviewComponent
} from '../application/response-to-call/response-to-call-preview/response-to-call-preview.component';
import { environment } from '../../../../environments/environment';
import {
  CertAboutConformityOfStudyPreviewComponent
} from '../application/cert-about-conformity-of-study/cert-about-conformity-of-study-preview/cert-about-conformity-of-study-preview.component';
import {
  LeaseOfABurialPlacePreviewComponent
} from '../application/lease-of-a-burial-place/lease-of-a-burial-place-preview/lease-of-a-burial-place-preview.component';
import {
  ApplicationForACemeterySpacePreviewComponent
} from '../application/application-for-a-cemetery-space/application-for-a-cemetery-space-preview/application-for-a-cemetery-space-preview.component';
import {
  RegistrationForTheSewageTreatmentPlantRegisterPreviewComponent
} from '../application/registration-for-the-sewage-treatment-plant-register/registration-for-the-sewage-treatment-plant-register-preview/registration-for-the-sewage-treatment-plant-register-preview.component';
import {
  WDeterminingPlanningFeeBeforeSaleOfPropertyPreviewComponent
} from '../application/w-determining-planning-fee-before-sale-of-property/w-determining-planning-fee-before-sale-of-property-preview/w-determining-planning-fee-before-sale-of-property-preview.component';
import {
  SubmittingAnInvestorLetterOfIntentPreviewComponent
} from '../application/submitting-an-investor-letter-of-intent/submitting-an-investor-letter-of-intent-preview/submitting-an-investor-letter-of-intent-preview.component';
import {
  GeneralApplicationPreviewComponent
} from '../application/general-application/general-application-preview/general-application-preview.component';
import {
  RemovalOfTreesOrShrubsPreviewComponent
} from '../application/removal-of-trees-or-shrubs/removal-of-trees-or-shrubs-preview/removal-of-trees-or-shrubs-preview.component';
import {
  MunicipalWasteDisposalPreviewComponent
} from '../application/municipal-waste-disposal/municipal-waste-disposal-preview/municipal-waste-disposal-preview.component';
import {
  CoordinatingTrafficOrganizationProjectsPreviewComponent
} from '../application/coordinating-traffic-organization-projects/coordinating-traffic-organization-projects-preview/coordinating-traffic-organization-projects-preview.component';
import {
  DecisionOnDevelopmentConditionsPreviewComponent
} from '../application/decision-on-development-conditions/decision-on-development-conditions-preview/decision-on-development-conditions-preview.component';
import {
  OpinionOfConformityOfPropertyDivisionMpzpPreviewComponent
} from '../application/opinion-of-conformity-of-property-division-mpzp/opinion-of-conformity-of-property-division-mpzp-preview/opinion-of-conformity-of-property-division-mpzp-preview.component';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentPreviewComponent
} from '../application/decision-on-determining-the-location-of-a-public-purpose-investment/decision-on-determining-the-location-of-a-public-purpose-investment-preview/decision-on-determining-the-location-of-a-public-purpose-investment-preview.component';
import { declarationAppUrls, notificationAppUrls } from '../../../app.routes';
import { ApplicationSignActionNamePipe } from '../../../pipes/application-sign-action-name.pipe';
import { ApplicationSendActionNamePipe } from '../../../pipes/application-send-action-name.pipe';
import { ApplicationDownloadPdfActionNamePipe } from '../../../pipes/application-download-pdf-action-name.pipe';

@Component({
  selector: 'app-approved-preview-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    CommonModule,
    SpinnerComponent,
    AlertContainerComponent,
    WLocationPropertyInRevitalizationAreaPreviewComponent,
    WCertificateFromMunicipalRegisterPreviewComponent,
    WExtractAndDraftMpzpPreviewComponent,
    WExtractAndDraftFromStudyPreviewComponent,
    CertAboutConformityOfUseWithMpzpPreviewComponent,
    OpinionOfConformityPreviewComponent,
    IrspaApplicationForTheProjectPreviewComponent,
    IrspaWarningOnTheConsultedDraftPreviewComponent,
    IrspaAmendTheActPreviewComponent,
    IrspaPreparationOfTheActPreviewComponent,
    PaymentStatusCheckerComponent,
    DocumentsInformationPreviewComponent,
    GeneralLetterPreviewComponent,
    ResponseToCallPreviewComponent,
    CertAboutConformityOfStudyPreviewComponent,
    LeaseOfABurialPlacePreviewComponent,
    ApplicationForACemeterySpacePreviewComponent,
    RegistrationForTheSewageTreatmentPlantRegisterPreviewComponent,
    WDeterminingPlanningFeeBeforeSaleOfPropertyPreviewComponent,
    SubmittingAnInvestorLetterOfIntentPreviewComponent,
    GeneralApplicationPreviewComponent,
    RemovalOfTreesOrShrubsPreviewComponent,
    MunicipalWasteDisposalPreviewComponent,
    CoordinatingTrafficOrganizationProjectsPreviewComponent,
    DecisionOnDevelopmentConditionsPreviewComponent,
    OpinionOfConformityOfPropertyDivisionMpzpPreviewComponent,
    DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentPreviewComponent,
    ApplicationSignActionNamePipe,
    ApplicationSendActionNamePipe,
    ApplicationDownloadPdfActionNamePipe
  ],
  providers: [UploaderAttachmentsService, PdfGeneratorService],
  templateUrl: './approved-preview-page.component.html'
})
export class ApprovedPreviewPageComponent implements OnInit, OnDestroy {

  readonly environment = environment;

  public applicationId: string | undefined =
    this.route.snapshot.params['appId'];

  public signStatus: 'success' | 'canceled' | string | undefined =
    this.route.snapshot.params['signStatus'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> =
    this.store$.selectSignal(selectApplication);

  public showPaymentBtn: Signal<boolean> = computed(() => !!this.application()?.service?.serviceAttachmentPositions?.filter(v => !!v?.fee)?.length);

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payum_token'] || this.route.snapshot.queryParams['amp;payum_token'];

  public canPay: boolean = !this.paymentToken;

  public contentUrl: string | undefined = this.route.snapshot.params['contentUrl'];

  public shipments: Signal<ShipmentAppEntityShipmentRead[]>
    = this.store$.selectSignal(selectShipments);

  public serviceType: Signal<ServiceAppEntityServiceRead | null> =
    this.store$.selectSignal(
      selectServiceByUrl(this.contentUrl || '')
    );

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    private uploaderService: UploaderAttachmentsService,
    private pdfGeneratorService: PdfGeneratorService,
    private alertService: AlertService
  ) {
  }

  public onPaymentComplete(v: boolean): void {
    if (v) {
      this.store$.dispatch(loadShipments({ applicationId: this.applicationId || '' }));
    }
    this.canPay = v;
  }

  public fakeSign(): void {
    this.store$.dispatch(fakeSignApplication({
      applicationId: this.applicationId || '',
      successFnc: () => {
      },
      failureFnc: () => {
      }
    }));
  }

  public signApplication(): void {
    // to do
    // need to handle success or failure messages
    this.store$.dispatch(
      signApplication({
        applicationId: this.applicationId || '',
        successFnc: (redirectUrl: string) => {
          window.location.href = redirectUrl;
        },
        failureFnc: () => {
        }
      })
    );
  }

  public sendApplication(): void {
    this.store$.dispatch(sendApplication({
        applicationId: this.applicationId || '',
        successFnc: () => {
          this.router.navigate(
            ['/wnioski-wyslane' + this.application()?.service?.url, this.applicationId],
            {
              state: { message: this.messageCodeByServiceUrl() }
            }
          );
        },
        failureFnc: () => {
        }
      })
    );
  }

  private messageCodeByServiceUrl(): string {
    const app = this.application();
    switch (true) {
      case notificationAppUrls.includes(app?.service?.url || ''): {
        return 'notificationSent';
      }
      case declarationAppUrls.includes(app?.service?.url || ''): {
        return 'declarationSent';
      }
      default: {
        return 'applicationSent';
      }
    }
  }

  public onDownloadApplicationPdf(event: Event): void {
    const id = this.application()?.document?.id;
    const name = this.application()?.document?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  public onDownloadSignedApplication(event: Event): void {
    const id = this.application()?.signedDocument?.id;
    const name = this.application()?.signedDocument?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  private handleMessages(): void {
    if (!!history.state?.message) {
      this.alertService.showByApplicationCode(history.state.message);
    }
    if (this.signStatus === 'success') {
      this.alertService.showByApplicationCode('applicationSigned');
    }
    if (this.signStatus === 'canceled') {
      this.alertService.showByApplicationCode('applicationNotSigned');
    }
  }

  public ngOnInit(): void {
    this.handleMessages();

    this.store$.dispatch(loadApplication({ id: this.applicationId || '' }));
    this.store$.dispatch(loadPayments({ applicationId: this.applicationId || '' }));
    this.store$.dispatch(loadShipments({ applicationId: this.applicationId || '' }));
    this.store$.dispatch(loadRoadOccupationTypes());
    this.store$.dispatch(loadServiceAttachmentPositions({ appId: this.applicationId || '' }));
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({ application: null }));
    this.store$.dispatch(setPayments({ applicationPayment: null }));
    this.store$.dispatch(setShipments({ shipments: [] }));
  }
}
